import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../features/auth";
import { IRosreestr } from "../../models/storeModels/IRosreestr";

function getInitialState() {
    const initialState: IRosreestr = {
        selectedRosreestrObjectsByGroupId: {},
        rosreestrObjectsInfoIsLoading: false,
        rosreestrObjectsInfoModalIsShown: false,
        numberOfSelectedRosreestrObjects: null
    }
    return initialState
}

export const rosreestrSlice = createSlice({
    name: 'rosreestr',
    initialState: getInitialState(),
    reducers: {
        setSelectedRosreestrObjectsByGroupId(state, action: PayloadAction<any>) {
            state.selectedRosreestrObjectsByGroupId = action.payload
        },
        setRosreestrObjectsInfoIsLoading(state, action: PayloadAction<boolean>) {
            state.rosreestrObjectsInfoIsLoading = action.payload
        },
        setRosreestrObjectsInfoModalIsShown(state, action: PayloadAction<boolean>) {
            state.rosreestrObjectsInfoModalIsShown = action.payload
        },
        setNumberOfSelectedRosreestrObjects(state, action: PayloadAction<any>) {
            state.numberOfSelectedRosreestrObjects = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const {
    setRosreestrObjectsInfoIsLoading,
    setRosreestrObjectsInfoModalIsShown,
    setNumberOfSelectedRosreestrObjects,
    setSelectedRosreestrObjectsByGroupId,
} = rosreestrSlice.actions

export const rosreestrReducer = rosreestrSlice.reducer;
